import { useEffect, useState } from "react";
import {
  fetchAllPlans,
  createPlan,
  deactivatePlan,
  activatePlan,
  updatePlan,
  deletePlan,
} from "../services/adminPlanService";
import PlanTable from "../components/plans/PlanTable";
import PlanForm from "../components/plans/PlanForm";
import { useToast } from "../../common/toast/ToastContext";
import "../styles/SubscriptionPlansManagement.css";

const SubscriptionPlansManagement = () => {
  const [plans, setPlans] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingPlan, setEditingPlan] = useState(null);
  const { showToast } = useToast();

  const loadPlans = async () => {
    const res = await fetchAllPlans();
    setPlans(res.data);
  };

  useEffect(() => { loadPlans(); }, []);

  const handleCreate = async (data) => {
    try {
      await createPlan(data);
      setShowForm(false);
      loadPlans();
    } catch {
      showToast("Something went wrong. Please try again.", "error");
    }
  };

  const handleUpdate = async (data) => {
    try {
      await updatePlan(editingPlan.id, data);
      setEditingPlan(null);
      loadPlans();
      showToast("Plan updated successfully.", "success");
    } catch {
      showToast("Something went wrong. Please try again.", "error");
    }
  };

  const handleToggleStatus = async (plan) => {
    try {
      if (plan.isActive) {
        await deactivatePlan(plan.id);
      } else {
        await activatePlan(plan.id);
      }
      loadPlans();
    } catch {
      showToast("Something went wrong. Please try again.", "error");
    }
  };

  const handleDelete = async (plan) => {
    const confirmed = window.confirm(`Are you sure you want to delete "${plan.name}"?`);
    if (!confirmed) return;

    try {
      const res = await deletePlan(plan.id);
      const { deleted, deactivated } = res.data;

      if (deleted) {
        setPlans((prev) => prev.filter((p) => p.id !== plan.id));
        showToast("Plan deleted successfully.", "success");
      } else if (deactivated) {
        setPlans((prev) =>
          prev.map((p) => (p.id === plan.id ? { ...p, isActive: false } : p))
        );
        showToast(
          "Plan has active subscriptions and could not be deleted. It has been deactivated instead.",
          "warning"
        );
      }
    } catch {
      showToast("Something went wrong. Please try again.", "error");
    }
  };

  return (
    <div>
      <div className="plans-header">
        <h2>Subscription Plans</h2>
        <button onClick={() => setShowForm(true)}>+ Add Plan</button>
      </div>

      <PlanTable
        plans={plans}
        onToggleStatus={handleToggleStatus}
        onEdit={(plan) => setEditingPlan(plan)}
        onDelete={handleDelete}
      />

      {(showForm || editingPlan) && (
        <PlanForm
          onSubmit={showForm ? handleCreate : handleUpdate}
          onClose={() => { setShowForm(false); setEditingPlan(null); }}
          initialData={editingPlan}
        />
      )}
    </div>
  );
};

export default SubscriptionPlansManagement;
